module.exports = __webpack_public_path__ + "img/img42.8e90b507.svg";